// extracted by mini-css-extract-plugin
export var container = "prefecture-selection-view-module--container--9c9c8";
export var prefectureLinkText = "prefecture-selection-view-module--prefectureLinkText--326f6";
export var prefectureRow = "prefecture-selection-view-module--prefectureRow--11120";
export var regionText = "prefecture-selection-view-module--regionText--c622c";